<router-outlet></router-outlet>
<spinner [message]="util?.messagespin" *ngIf="util?.loading"></spinner>